import { Button, Card, Col, Input, InputNumber, Row, Select } from "antd";
import React, { useState } from "react";
import { RiAddCircleFill } from "react-icons/ri";
import { CgCloseO } from "react-icons/cg";
import { TbCurrencyDollar } from "react-icons/tb";

import "./BankAccounts.css";
import { accountType } from "../../data";

function BankAccounts({ data }) {
  const [checked, setChecked] = useState(false);

  const [bankAccounts, setBankAccounts] = useState([
    {
      name: "",
      accountType: "",
      accountNumber: "",
      balance: "",
    },
  ]);

  const addAnotherBankAccount = () => {
    setBankAccounts([
      ...bankAccounts,

      {
        name: "",
        accountType: "",
        accountNumber: "",
        balance: "",
      },
    ]);
  };

  const onRemoveBankAccount = (index) => {
    const newBankAccounts = [...bankAccounts];
    newBankAccounts.splice(index, 1);
    setBankAccounts(newBankAccounts);
  };
  return (
    <Row className="bank-accounts">
      <Col span={24}>
        <Card
          title="Bank Accounts"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <Row justify="start" gutter={[8, 0]}>
                  <Col className="header-row" span={8}>
                    <span>Name</span>
                  </Col>
                  <Col className="header-row" span={8}>
                    <span>Account Type</span>
                  </Col>
                  <Col className="header-row" span={4}>
                    <span>Account Number</span>
                  </Col>
                  <Col className="header-row" span={3}>
                    <span>Balance</span>
                  </Col>
                </Row>
              </Col>
              {bankAccounts.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={8}>
                        <Input placeholder="Name" />
                      </Col>
                      <Col span={8}>
                        <Select placeholder="Account type" options={accountType} style={{ width: "100%" }} />
                      </Col>
                      <Col span={4}>
                        <Input placeholder="Account number" />
                      </Col>
                      <Col span={3}>
                        <InputNumber placeholder="Balance" addonBefore={<TbCurrencyDollar size={16} /> }/>
                      </Col>
                      {bankAccounts.length > 1 ? (
                        <Col span={1}>
                          <CgCloseO
                            className="delete-btn"
                            size={20}
                            onClick={() => onRemoveBankAccount(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  onClick={() => addAnotherBankAccount()}
                  className="add-icon-btn"
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Pet</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={6}>
                          <span>Name</span>
                        </Col>
                        <Col span={6}>
                          <span>Account Type</span>
                        </Col>
                        <Col span={6}>
                          <span>Account Number</span>
                        </Col>
                        <Col span={6}>
                          <span>Balance</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.make}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.model}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.color}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.licenseNo}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>
                        Applicant did not provide any bank account information.
                      </p>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default BankAccounts;
